import { Box } from "@mui/material";
import React, { useState, useEffect, useRef } from "react";

const LazyImage = ({ src, defaultVisible = false, ...props }) => {
    const [isVisible, setIsVisible] = useState(defaultVisible);
    const imgRef = useRef();

    useEffect(() => {
        const imgEl = imgRef.current;
        if (!imgEl) return;

        if ("IntersectionObserver" in window) {
            const observer = new IntersectionObserver(
                (entries, obs) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            setIsVisible(true);
                            obs.unobserve(entry.target);
                        }
                    });
                },
                { rootMargin: "300px" }
            );
            observer.observe(imgEl);
            return () => observer.disconnect();
        } else {
            setIsVisible(true);
        }
    }, []);

    return (
        <Box
            component={'img'}
            ref={imgRef}
            {...(isVisible ? { src } : {})}
            {...props}
        />
    );
};

export default LazyImage;